<template>
  <v-row>
    <v-col :class="`${arabic ? 'arFont' : 'enFont'}`" cols="6" md="3" v-for="(key, i) in language_details_keys" :key="`lang-${i}`">
      <span style="font-size: 12px; font-weight: 700; text-transform: capitalize;">{{ i18n[key] }}</span>
      <br />
      <span>{{ transform(resource[key], "bool") }}</span>
    </v-col>
    <v-col cols="12">
      <v-btn small color="primary" @click.prevent="$emit('editResource', 'languages', {})">Edit</v-btn>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: ["resource"],
  data() {
    return {
      language_details_keys: [
        "language_started",
        "a_1_started",
        "a_1_finished",
        "a_1_passed",
        "a_2_started",
        "a_2_finished",
        "a_2_passed",
        "a_2_certificate",
        "b_1_started",
        "b_1_finished",
        "b_1_passed",
        "b_1_certificate",
        "b_2_started",
        "b_2_finished",
        "b_2_passed",
        "b_2_certificate",
        "b_1_certificate_submited",
        "b_2_certificate_submited",
      ],
    }
  },
  methods: {
    formatDateToCurrentLocale(date) {
      let new_date = new Date(date);
      return [
        new_date.toLocaleDateString(this.arabic ? "ar" : "en", {
          day: "numeric",
          year: "numeric",
          month: "short",
        }),
        new_date.toLocaleTimeString(this.arabic ? "ar" : "en"),
      ];
    },
    transform(value, to) {
      switch (to) {
        case "bool":
          return Boolean(value) ? "Yes" : "No";
      }
    },
  },
  computed: {
    visaKeys() {
      return Object.keys(this.resource).filter((key) => key.startsWith("visa_"));
    },
    i18n() {
      return this.$store.state.i18n[this.$store.state.language];
    },
    arabic() {
      if (this.$store.state.language == "ar") return true;
    },
  },
};
</script>
